
export function setDigioOption(env, logoURL = "", primaryColor = "", secondaryColor = "", call_fun, is_iframe = true) {
  const redirectUrl = window.location.origin + window.location.pathname;

  var options = {
    environment: env,
    callback: function (response) {
      if (response.hasOwnProperty("error_code")) {
        return console.log("error occurred in process");
      } else {
        call_fun();
        console.log("Signing completed successfully");
      }
    },
    event_listener: function (event) {
      console.log("Digio Event:", event);
    },
    is_iframe: is_iframe,
    logo: logoURL,
    theme: {
      primaryColor: primaryColor,
      secondaryColor: secondaryColor
    }
  }

  if (!is_iframe) {
    options.redirect_url = redirectUrl;
  }

  return options;
}